import type { ReactNode } from "react";

export interface FrameBottomBarProps {
  children: ReactNode;
  /** Clearance hint only — it is not forwarded to the bar. Frame reads it off this slot to size
   *  its scroller padding: `floating` overlays the page, so Frame pads by the bar's footprint;
   *  `docked` (default) is a shelf that reserves its own in-flow space. The child `BottomBar`
   *  takes its shape from its own `variant`, so this MUST be set to the same value or the page
   *  gets one bar's shape with the other's clearance. */
  variant?: "floating" | "docked";
}

/**
 * Mobile global navigation. Frame renders this fixed at the viewport bottom
 * (z-30, mobile-only).
 */
export function FrameBottomBar({ children }: FrameBottomBarProps) {
  return <>{children}</>;
}
